import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { SuggestProvider } from './SuggestOverlay';

interface AppLayoutProps {
  children: ReactNode;
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  const { pathname } = useLocation();
  const isVendorPage = pathname.startsWith('/vendor');

  // Vendor portal has its own layout — skip advisor sidebar
  if (isVendorPage) {
    return <>{children}</>;
  }

  return (
    <div className="flex min-h-screen w-full">
      <AppSidebar />
      <div className="flex-1 min-h-0 flex flex-col overflow-auto">
        <SuggestProvider>
          {children}
        </SuggestProvider>
      </div>
    </div>
  );
};
